export default __webpack_public_path__ + "16.png";